import { type ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface PageHeaderTab {
  id: string;
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  tabs?: PageHeaderTab[];
  className?: string;
}

export function PageHeader({ title, description, actions, tabs, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-6', className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 className="text-xl font-bold text-yhelp-black dark:text-white">{title}</h2>
          {description ? (
            <p className="mt-1 text-sm text-neutral-600 dark:text-neutral-400">{description}</p>
          ) : null}
        </div>
        {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
      </div>
      {tabs && tabs.length > 0 ? (
        <div className="mt-4 flex gap-1 border-b border-neutral-200 dark:border-neutral-800">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={tab.onClick}
              className={cn(
                'border-b-2 px-3 py-2 text-sm font-medium transition-colors duration-fast motion-reduce:transition-none',
                tab.active
                  ? 'border-[var(--tenant-primary,#FFE600)] text-yhelp-black dark:text-white'
                  : 'border-transparent text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-200',
              )}
            >
              {tab.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
